import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Documento } from '../model/documento';
import { RaizComponent } from '../raiz/raiz.component';
import { NotificationService } from '../_services/notification.service';
import { ServicioGeneral } from '../_services/servicio-general.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { UserService } from '../_services/user.service';
import { NotificationI18nService } from '../core/util/notification-i18n.service';
declare let pdfjsLib: any;

@Component({
  selector: 'app-csv-viewer',
  templateUrl: './csv-viewer.component.html',
  styleUrls: ['./csv-viewer.component.css']
})
export class CsvViewerComponent extends UnsubscribeOnDestroy implements OnInit {
  mensajeSpinner: string;
  cargandoDatos: boolean = false;
  documento: string = ''
  @ViewChild('pdfContainer', { static: true }) pdfContainer!: ElementRef<HTMLDivElement>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private _servicioGeneral: ServicioGeneral,
    private notificationI18n: NotificationI18nService,
    private spinner: NgxSpinnerService
  ){
    super();
  }

  ngOnInit(): void {
    this.documento = '';
    this.route.queryParams
    
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
      if(params["t"]){
        this.cargandoDatos = true;
        const csv = params['t'];
        if(csv){
          this.mostrarSpinnerMsg("Validando CSV....");
          this._servicioGeneral
            .cardTramiteDoAction({
              action: 'validarCSV',
              value: csv,
            })
            
              .pipe(takeUntil(this.destroy$))
              .subscribe({
              next: (response:any) => {
                if(response.message.status == '603' || !response.documentob64){
                  this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_EXISTE_EL_DOCUMENTO_CON_EL_CSV_RECIBIDO')
                  this.router.navigate(['inicio']);
                }  
                else if (response.documentob64) {
                  this.documento = response.documentob64;
                  this.loadPDF(response.documentob64);              
                }
                
              },
              error: (error) => {
                this.ocultarSpinner()
                this.router.navigate(['inicio']);
                this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_EXISTE_EL_DOCUMENTO_CON_EL_CSV_RECIBIDO')
              },
              complete:() => {
                this.ocultarSpinner();
                this.cargandoDatos = false;
              }
            });
        }
        else{
          this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_HA_RECIBIDO_CSV_A_RECUPERAR');
          this.router.navigate(['inicio']);
        }
      }
    });
  }
  logout(): void {
    this.tokenStorage.signOut();
  } 
  mostrarSpinnerMsg(mensaje: string) {
    this.mensajeSpinner = mensaje;
    this.spinner.show("csv_viewer_spinner");
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 60000);
  }
  ocultarSpinner() {
    this.spinner.hide("csv_viewer_spinner");
  }  
  private loadPDF(base64: string): void {
    // Decodifica el Base64
    /*  tipo="data:application/pdf;base64," */
    const pdfData = atob(base64);

    const loadingTask = pdfjsLib.getDocument({ data: pdfData });

    loadingTask.promise.then((pdf: any) => {
      const numPages = pdf.numPages; // Obtener el número de páginas

      // Iterar sobre cada página
      for (let pageNum = 1; pageNum <= numPages; pageNum++) {
        pdf.getPage(pageNum).then((page: any) => {
          const viewport = page.getViewport({ scale: 2 });

          // Crear un canvas para cada página
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          // Renderizar la página en el canvas
          const renderContext = {
            canvasContext: context,
            viewport: viewport
          };
          page.render(renderContext);

          // Añadir el canvas al contenedor
          this.pdfContainer.nativeElement.appendChild(canvas);
        });
      }
      this.ocultarSpinner()
    }).catch((error: any) => {
      this.ocultarSpinner()
      console.error('Error al cargar el PDF:', error);
    });
  }  
  /* Documento */
  openPdf(document: string): void {
    const byteCharacters = atob(document ?? '');
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const opcionesVentana = 'width=800,height=600,scrollbars=yes';
    const url = URL.createObjectURL(blob);

    window.open(url, "_blank", opcionesVentana)

    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 100);
  }  
}
